import { render, staticRenderFns } from "./ManageSpending.vue?vue&type=template&id=38759dbd&scoped=true"
import script from "./ManageSpending.vue?vue&type=script&lang=js"
export * from "./ManageSpending.vue?vue&type=script&lang=js"
import style0 from "./ManageSpending.vue?vue&type=style&index=0&id=38759dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38759dbd",
  null
  
)

export default component.exports